// File: /opt/dev_environment/assets/workspace/app-init/src/App.js

import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';

import { useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Layout from './components/Layout/Layout';
import StartPage from './pages/StartPage/StartPage';
import VerbenPage from './pages/VerbenPage/VerbenPage';
import VokabelnPage from './pages/VokabelnPage/VokabelnPage';
import StatistikPage from './pages/StatistikPage/StatistikPage';
import { VocabularyProvider } from './context/VocabularyContext';

// Auth pages
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import VerifyEmailPage from './pages/auth/VerifyEmailPage';

/**
 * Wrapper for all protected app routes.
 * VocabularyProvider is shared across all protected pages so state persists
 * during navigation.
 */
function ProtectedApp() {
  return (
    <ProtectedRoute>
      <VocabularyProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<StartPage />} />
            <Route path="/verben" element={<VerbenPage />} />
            <Route path="/vokabeln" element={<VokabelnPage />} />
            <Route path="/statistik" element={<StatistikPage />} />
            <Route path="/lernen" element={<Navigate to="/verben" replace />} />
          </Routes>
        </Layout>
      </VocabularyProvider>
    </ProtectedRoute>
  );
}

function App() {
  const navigate = useNavigate();

  // Listen for session expired events (from apiClient)
  useEffect(() => {
    const handleSessionExpired = () => {
      navigate('/login', { replace: true });
    };

    window.addEventListener('auth:session-expired', handleSessionExpired);
    return () => {
      window.removeEventListener('auth:session-expired', handleSessionExpired);
    };
  }, [navigate]);

  return (
    <Routes>
      {/* Public routes — auth pages */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />

      {/* Protected routes — main app (all share VocabularyProvider & Layout) */}
      <Route path="/*" element={<ProtectedApp />} />
    </Routes>
  );
}

export default App;